// Clickeate — scripts propios (vanilla, sin librerías)
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContador();
  initGaleriaProducto();
  initVariantesProducto();
});

function initReveals() {
  var els = document.querySelectorAll('.ck-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ck-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-ck-delay') || 0;
          setTimeout(function () { entry.target.classList.add('ck-visible'); }, Number(delay));
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-ck-contador]');
  if (!els.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-ck-contador'));
        var suffix = el.getAttribute('data-ck-sufijo') || '';
        if (reduce || isNaN(target)) {
          el.textContent = target + suffix;
          obs.unobserve(el);
          return;
        }
        var start = null;
        var duracion = 1400;
        function paso(ts) {
          if (!start) start = ts;
          var progreso = Math.min((ts - start) / duracion, 1);
          var valor = Math.round(target * (1 - Math.pow(1 - progreso, 3)));
          el.textContent = valor + suffix;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        obs.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-ck-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-ck-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-ck-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('ck-mini-activa'); });
      mini.classList.add('ck-mini-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-ck-form-producto]');
  if (!form) return;
  var selects = form.querySelectorAll('[data-ck-opcion]');
  if (!selects.length) return;
  var dataEl = document.querySelector('[data-ck-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-ck-precio]');
  var precioCompareEl = document.querySelector('[data-ck-precio-compare]');
  var botonEl = form.querySelector('[data-ck-btn-comprar]');

  function moneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function actualizar() {
    var elegido = Array.prototype.map.call(selects, function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === elegido[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = moneda(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = moneda(variante.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    var idInputEl = form.querySelector('input[name="id"]');
    if (botonEl) {
      var textoEl = botonEl.querySelector('span');
      if (variante.available) {
        botonEl.disabled = false;
        if (idInputEl) idInputEl.disabled = false;
        if (textoEl) textoEl.textContent = botonEl.getAttribute('data-texto-disponible');
      } else {
        botonEl.disabled = true;
        if (idInputEl) idInputEl.disabled = true;
        if (textoEl) textoEl.textContent = botonEl.getAttribute('data-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}
